import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetFlowComponentList = createAsyncThunk(
  "FlowComponent/GetFlowComponentList",
  async (parameters, { rejectWithValue }) => {
    try {
     await initializeApiClient("application/json");
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowComponent/GetFlowComponentList",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "appccccc");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




const FlowComponent = createSlice({
  name: "FlowComponent",
  initialState: {
    //------------- GetFlowComponentList ---------------------
    FlowComponent: [],
    loadingFlowComponent: false,
    errorFlowComponent: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetFlowComponentList.pending, (state, action) => {
        state.loadingFlowComponent = true;
        state.FlowComponent = action.payload;
        state.errorFlowComponent = null;
      })
      .addCase(GetFlowComponentList.fulfilled, (state, action) => {
        state.loadingFlowComponent = false;
        state.FlowComponent = action.payload;
      })
      .addCase(GetFlowComponentList.rejected, (state, action) => {
        state.loadingFlowComponent = false;
        state.FlowComponent = action.payload;
      });
   
   
  },
});


export default FlowComponent.reducer;
